<template>

    <CobaltDashboard :info="null" :company="null" :withFilterBar="false" contentClasses="single ps-0 pe-0" dashboardClasses="single">

        <div class="np-home">
            <div class="row h-100">
                <div class="col d-flex flex-column h-100">
                    <SummaryFreemium />
                </div>
            </div> 
        </div>
    
    </CobaltDashboard>

</template>

<script>
import { useSettingsStore } from '@/stores/settingsStore.js'
import { useNotificationStore } from "@/stores/notificationStore"

import CobaltDashboard from "@/components/dashboard/CobaltDashboard.vue"
import CobaltProfile   from "@/components/dashboard/parts/CobaltProfile.vue"
import SummaryFreemium from "@/components/dashboard/home/SummaryFreemium.vue"

import "qalendar/dist/style.css"

export default {
    components: {
        CobaltDashboard,
        CobaltProfile,
        SummaryFreemium
    },
    data() {
        return {
        }
    }
}
</script>

<style>
</style>